import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import getDataPoint from '../utils/getDataPoint';
import { translate } from './Translate';
import { DataStore, TranslationStore } from '../stores';
import { ShareClass } from '../models/entity';
import { Theme } from '../models/Theme';

const ResultsMetaWrapper = styled<any, any>(
    'div',
    'resultsMetaWrapper',
    'resultsMeta'
)`
    ${propStyles};
    &:empty {
        display: none;
    }
`;

ResultsMetaWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'body',
    fontWeight: 'normal',
    fontSize: 'sm',
    paddingX: 'md',
    paddingY: 'md',
    color: 'body',
};

const ResultsMetaSummary = styled<any, any>(
    'div',
    'resultsMetaSummary',
    'resultsMeta'
)`
    ${propStyles};
`;

ResultsMetaSummary.defaultProps = {};

const ResultsMetaAsAtDate = styled<any, any>(
    'div',
    'resultsMetaAsAtDate',
    'resultsMeta'
)`
    ${propStyles};
`;

ResultsMetaAsAtDate.defaultProps = {};

const rightAlignStyleProps = {
    order: 1,
    margin: '0 0 0 auto',
};

interface ResultsMetaProps {
    theme?: Theme;
    dataStore?: DataStore;
    translationStore?: TranslationStore;
    shareClasses: Array<ShareClass>;
}

@inject('dataStore')
@inject('translationStore')
@observer
class ResultsMeta extends Component<ResultsMetaProps> {
    @computed
    get resultsMeta() {
        const { resultsMeta = {} } = this.props.dataStore.config.explorer || {};
        return resultsMeta;
    }

    @computed
    get resultSummary() {
        return this.resultsMeta.resultSummary;
    }

    @computed
    get asAtDate() {
        return this.resultsMeta.asAtDate;
    }

    @computed
    get asAtDateValue() {
        const { dataStore, translationStore } = this.props;
        const [firstShareClass] = this.props.shareClasses;
        const { label = '', data = {} as any } = this.asAtDate;
        const value = getDataPoint({
            dataStore,
            dataConfig: data,
            shareClass: firstShareClass,
            locale: this.props.dataStore.culture,
        });

        const asAtDateValue = translate(translationStore, label, {
            value,
        });

        return asAtDateValue;
    }

    @computed
    get resultSummaryValue() {
        const { dataStore, translationStore } = this.props;
        const { label = '' } = this.resultSummary;
        const { total = 0, funds = [] } = dataStore;

        const resultSummaryValue = translate(translationStore, label, {
            count: funds.length,
            total,
        });

        return resultSummaryValue;
    }

    render() {
        const { theme } = this.props;
        return (
            <ResultsMetaWrapper {...theme.ResultsMetaWrapper}>
                {this.resultSummary && (
                    <ResultsMetaSummary
                        aria-live="polite"
                        {...(this.resultSummary.align === 'right' &&
                            rightAlignStyleProps)}
                        {...theme.ResultsMetaSummary}
                    >
                        {this.resultSummaryValue}
                    </ResultsMetaSummary>
                )}
                {this.asAtDate && (
                    <ResultsMetaAsAtDate
                        {...(this.asAtDate.align === 'right' &&
                            rightAlignStyleProps)}
                        {...theme.ResultsMetaAsAtDate}
                    >
                        {this.asAtDateValue}
                    </ResultsMetaAsAtDate>
                )}
            </ResultsMetaWrapper>
        );
    }
}

export default withTheme(ResultsMeta);



// WEBPACK FOOTER //
// ./src/Components/ResultsMeta.tsx